import React, { useEffect } from 'react';
import { PageHeader, Tabs, Input, Tree } from 'antd';

import CodeHighlight from 'code-highlight';

// import all the styles
import "code-highlight/lib/style.css";
import "highlight.js/styles/github-gist.css";

import * as IMI from '../lib/ManiaFrameWork/js/mania';

const { TabPane } = Tabs;
const routes = [
  {
    path: 'AutoComplete',
    breadcrumbName: 'AutoComplete',
  },
];
const { TreeNode, DirectoryTree } = Tree;

const AutoComplete_ = () => {
  useEffect(() => {
    var list = [
      "라그나로크 제로", "니드포스피드엣지", "리니지M", "오버히트", "배틀그라운드", "테라m",
      "열혈강호forkakao", "AxE", "페이트 그랜드 오더", "리니지", "던전앤파이터", "바람의나라",
      "메이플스토리", "블레이드앤소울", "리니지2 레볼루션", "아이온", "마비노기", "마비노기영웅전",
      "리니지2", "거상", "피파온라인3", "다크에덴", "테일즈위버", "뮤오리진[Android]", "뮤오리진[iOS]",
      "아키에이지", "리그오브레전드", "테라", "서든어택", "오버워치", "모두의마블 for kakao", "세븐나이츠",
      "레이븐", "별이되어라!", "포켓 메이플스토리", "서머너즈워", "아이모", "몬스터길들이기", "클래시 오브 클랜",
      "레알팜", "히트캔", "괴리성밀리언아서", "하얀고양이 프로젝트", "갓오브하이스쿨"
    ];
    new IMI.AutoComplete(document.querySelector('#autocomplete'), {
      data : list,
      // dataSearchKey:'N',
      // dataValueKey:'C',
      // indexMatch: true,
      clickEvent:function (el, data) {
        console.log(this, data)
      }
    });
  }, []);


  return (
    <>
      <PageHeader title="AutoComplete" breadcrumb={{ routes }} subTitle="AutoComplete" style={{ padding: 10 }} />
      <div className="MF_area">
        <div className="autocomplete_wrapper">
          <Input placeholder="Search Games" id="autocomplete" />
        </div>
      </div>

      <div className="codeArea">
        <Tabs defaultActiveKey="1">
          <TabPane tab="HTML" key="1">
            <CodeHighlight language="HTML">
              {`<div class="autocomplete_wrapper">
  <input placeholder="Search Games" id="autocomplete" />
</div>`}
            </CodeHighlight>
          </TabPane>
          <TabPane tab="JAVASCRIPT" key="2">
            <CodeHighlight language="JS">
              {`var list = [
  "라그나로크 제로", "니드포스피드엣지", "리니지M", "오버히트", "배틀그라운드", "테라m",
  "열혈강호forkakao", "AxE", "페이트 그랜드 오더", "리니지", "던전앤파이터", "바람의나라",
  "메이플스토리", "블레이드앤소울", "리니지2 레볼루션", "아이온", "마비노기", "마비노기영웅전",
  "리니지2", "거상", "피파온라인3", "다크에덴", "테일즈위버", "뮤오리진[Android]", "뮤오리진[iOS]",
  "아키에이지", "리그오브레전드", "테라", "서든어택", "오버워치", "모두의마블 for kakao", "세븐나이츠",
  "레이븐", "별이되어라!", "포켓 메이플스토리", "서머너즈워", "아이모", "몬스터길들이기", "클래시 오브 클랜",
  "레알팜", "히트캔", "괴리성밀리언아서", "하얀고양이 프로젝트", "갓오브하이스쿨"
];
new AutoComplete(document.querySelector('#autocomplete'), {
      data : list,
      // dataSearchKey:'N',
      // dataValueKey:'C',
      // indexMatch: true,
      clickEvent:function (el, data) {
        console.log(this, data)
      }
    });`}
            </CodeHighlight>
          </TabPane>
        </Tabs>
      </div>
      <h3>Data List</h3>
      <DirectoryTree multiple defaultExpandAll >
        <TreeNode title="Lists" key="0-0">
          <TreeNode title="라그나로크 제로" key="0-0-0" isLeaf />
          <TreeNode title="니드포스피드엣지" key="0-0-1" isLeaf />
          <TreeNode title="리니지M" key="0-0-2" isLeaf />
          <TreeNode title="오버히트" key="0-0-3" isLeaf />
          <TreeNode title="배틀그라운드" key="0-0-4" isLeaf />
          <TreeNode title="테라m" key="0-0-5" isLeaf />
          <TreeNode title="AxE" key="0-0-6" isLeaf />
          <TreeNode title="페이트 그랜드 오더" key="0-0-7" isLeaf />
          <TreeNode title="리니지" key="0-0-8" isLeaf />
          <TreeNode title="던전앤파이터" key="0-0-9" isLeaf />
          <TreeNode title="바람의나라" key="0-0-10" isLeaf />
          <TreeNode title="리니지2" key="0-0-11" isLeaf />
          <TreeNode title="거상" key="0-0-12" isLeaf />
          <TreeNode title="피파온라인3" key="0-0-13" isLeaf />
          <TreeNode title="다크에덴" key="0-0-14" isLeaf />
          <TreeNode title="테일즈위버" key="0-0-15" isLeaf />
          <TreeNode title="뮤오리진[Android]" key="0-0-16" isLeaf />
          <TreeNode title="뮤오리진[iOS]" key="0-0-17" isLeaf />
          <TreeNode title="아키에이지" key="0-0-18" isLeaf />
          <TreeNode title="리그오브레전드" key="0-0-19" isLeaf />
          <TreeNode title="테라" key="0-0-20" isLeaf />
          <TreeNode title="서든어택" key="0-0-21" isLeaf />
          <TreeNode title="오버워치" key="0-0-22" isLeaf />
          <TreeNode title="모두의마블 for kakao" key="0-0-23" isLeaf />
          <TreeNode title="세븐나이츠" key="0-0-24" isLeaf />
          <TreeNode title="레이븐" key="0-0-25" isLeaf />
          <TreeNode title="별이되어라!" key="0-0-26" isLeaf />
          <TreeNode title="포켓 메이플스토리" key="0-0-27" isLeaf />
          <TreeNode title="서머너즈워" key="0-0-28" isLeaf />
          <TreeNode title="아이모" key="0-0-29" isLeaf />
          <TreeNode title="몬스터길들이기" key="0-0-30" isLeaf />
          <TreeNode title="클래시 오브 클랜" key="0-0-31" isLeaf />
          <TreeNode title="레알팜" key="0-0-32" isLeaf />
          <TreeNode title="히트캔" key="0-0-33" isLeaf />
          <TreeNode title="괴리성밀리언아서" key="0-0-34" isLeaf />
          <TreeNode title="하얀고양이 프로젝트" key="0-0-35" isLeaf />
          <TreeNode title="갓오브하이스쿨" key="0-0-36" isLeaf />
        </TreeNode>
      </DirectoryTree>
    </>
  );
}

export default AutoComplete_;
